import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, SerializationContext, DataModelBuilder,
  SerializedData, mapToData, cloneMap, isSameMap } from '../dto/dto.js';

export class FeaturedMetadata extends DataModel {
  static readonly TYPE_ID: string = '99f29a0ba83b415cbabcc9fc05eb49ea';

  constructor(
        public readonly featuredBusinesses: Map<string, number>,
  ) {
    super();
  }

  get $typeId(): string {
    return FeaturedMetadata.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FeaturedMetadata {
    return new FeaturedMetadata(
        MapUtils.getMap(map, 'featuredBusinesses', (k: string, v: unknown) => {
          return {
            key: k,
            value: v as number,
          };
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'featuredBusinesses': mapToData(this.featuredBusinesses, (k: string, v: number) => {
        return {
          key: k,
          value: v,
        };
      }),
    };
  }

  clone(): this {
    return new FeaturedMetadata(
        cloneMap(this.featuredBusinesses),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameMap(other.featuredBusinesses, this.featuredBusinesses);
  }
}

export class FeaturedMetadataBuilder extends DataModelBuilder<FeaturedMetadata> {
  build(context: SerializationContext, map: SerializedData): FeaturedMetadata {
    return FeaturedMetadata.fromMap(context, map);
  }
}
